import { sanitizePath } from './sanitizePath';

const PAGE_NAMES: Record<string, string> = {
  '/portal/home': 'Home',
  '/portal/dashboard': 'Dashboard',
  '/portal/journeys': 'Journeys',
  '/portal/shipments': 'Shipments',
  '/portal/journey/:id': 'Journey Details',
  '/portal/fleet-view': 'Fleet View',
  '/portal/artyc-ai': 'Artyc AI',
  '/portal/shippers': 'Shippers',
  '/portal/events': 'Events',
  '/portal/orders': 'Orders',
  '/portal/groups': 'Groups',
  '/portal/users': 'Users',
  '/portal/companies': 'Companies',
  '/portal/company-profile': 'Company Profile',
  '/portal/field-personnel': 'Field Personnel',
  '/portal/pcb-tests': 'PCB Tests',
  '/portal/customer-cost-reports': 'Cost Reports',
  '/portal/cost-calculator': 'Cost Calculator',
  '/portal/cost-calculator/:id': 'Cost Calculator',
  '/portal/support': 'Support',
  '/cost-report/:id': 'Cost Report',
  '/login': 'Login',
  '/auth/mfa': 'MFA',
  '/auth/session-locked': 'Session Locked',
  '/forgot-password': 'Forgot Password',
  '/reset-password/:token': 'Reset Password',
  '/registration-confirmation': 'Registration Confirmation',
  '/password-reset-success': 'Password Reset Success',
  '/unauthorized': 'Unauthorized',
};

const titleCase = (segment: string): string =>
  segment
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const pageName = (pathname: string): string => {
  const clean = sanitizePath(pathname);
  if (PAGE_NAMES[clean]) return PAGE_NAMES[clean];

  const segments = clean
    .split('/')
    .filter((s) => s && s !== 'portal' && s !== ':id' && s !== ':token');
  if (segments.length === 0) return 'Home';
  return titleCase(segments[segments.length - 1]);
};
